module.exports = __webpack_public_path__ + "static/img/refund.6af2cd29.png";